import { TAccountFeatureMap } from '../../multiLoanDashboard/AccountFeatureEvaluator/AccountFeatureEvaluator';
import { WidgetRenderer } from '../../multiLoanDashboard/WidgetRenderer/WidgetRenderer';

export const OfferReadyDashboard = ({
    accountId,
    features
}: {
    accountId: string;
    features: TAccountFeatureMap;
}) => {
    return (
        <div className="bg-structure-100">
            <div className="mx-auto max-w-[1240px] px-l py-[50px]">
                <div className="space-y-2xl">
                    <WidgetRenderer accountId={accountId} features={features} />
                </div>
            </div>
        </div>
    );
};
